import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelText as _vModelText, vModelRadio as _vModelRadio } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "container" }, null, -1)
const _hoisted_3 = { class: "d-flex px-8 mt-5" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex mx-9 position-relative"
}
const _hoisted_5 = { class: "d-flex px-2" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-8" }
const _hoisted_8 = {
  class: "row",
  style: {"margin-left":"10px"}
}
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "card-body py-3" }
const _hoisted_11 = { class: "table-responsive" }
const _hoisted_12 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Nama Sekolah"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status Dokumen PKS"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tanggal Permintaan"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, " Perubahan Progress Sekolah "),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tanggal Konfirmasi"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status Konfirmasi Legal"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Aksi")
  ])
], -1)
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "text-left" }
const _hoisted_16 = {
  key: 0,
  class: "text-center",
  style: {"color":"#00d192"}
}
const _hoisted_17 = {
  key: 1,
  class: "text-center",
  style: {"color":"#e50200"}
}
const _hoisted_18 = {
  key: 2,
  class: "text-center"
}
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = {
  key: 3,
  class: "text-center",
  style: {"color":"#00d192"}
}
const _hoisted_21 = {
  key: 4,
  class: "text-center",
  style: {"color":"#e50200"}
}
const _hoisted_22 = {
  key: 5,
  class: "text-center"
}
const _hoisted_23 = {
  key: 6,
  class: "text-center"
}
const _hoisted_24 = {
  key: 7,
  class: "text-center"
}
const _hoisted_25 = {
  key: 8,
  class: "text-center"
}
const _hoisted_26 = {
  key: 9,
  class: "text-center"
}
const _hoisted_27 = {
  key: 10,
  class: "text-center",
  style: {"color":"#00d192"}
}
const _hoisted_28 = {
  key: 11,
  class: "text-center",
  style: {"color":"#e50200"}
}
const _hoisted_29 = {
  key: 12,
  class: "text-center"
}
const _hoisted_30 = { class: "text-center" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { key: 1 }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = { class: "row mt-5 mb-5" }
const _hoisted_36 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_37 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_38 = ["label", "value"]
const _hoisted_39 = { class: "p-3" }
const _hoisted_40 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_41 = { class: "pagination" }
const _hoisted_42 = {
  class: "modal fade",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  id: "kt_modal_confirm_legal"
}
const _hoisted_43 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_44 = { class: "modal-content rounded" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header pb-0 border-0 justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title mb-6" }, "Detail Konfirmasi Legal"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
  ])
], -1)
const _hoisted_46 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-15" }
const _hoisted_47 = { class: "row" }
const _hoisted_48 = { class: "col-xl-12 mb-8" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Nama Sekolah", -1)
const _hoisted_50 = { class: "col-xl-6 mb-8" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Penanggung Jawab", -1)
const _hoisted_52 = { class: "col-xl-6 mb-8" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Tanggal", -1)
const _hoisted_54 = { class: "row" }
const _hoisted_55 = { class: "col-xl-6 mb-8" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Sales", -1)
const _hoisted_57 = { class: "col-xl-6 mb-8" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Permintaan Perubahan Progress", -1)
const _hoisted_59 = { class: "row" }
const _hoisted_60 = { class: "col-xl-6 mb-8" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Catatan", -1)
const _hoisted_62 = {
  key: 0,
  class: "col-xl-12 mb-2"
}
const _hoisted_63 = /*#__PURE__*/_createElementVNode("span", { class: "form-label fw-bolder text-dark fs-6" }, "Persetujuan Legal", -1)
const _hoisted_64 = [
  _hoisted_63
]
const _hoisted_65 = { key: 1 }
const _hoisted_66 = {
  key: 2,
  class: "col-xl-12"
}
const _hoisted_67 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "Silahkan dicek kembali dokumen yang akan diapprove atau dicancel", -1)
const _hoisted_68 = [
  _hoisted_67
]
const _hoisted_69 = { key: 3 }
const _hoisted_70 = {
  key: 4,
  class: "col-xl-6"
}
const _hoisted_71 = {
  class: "btn-group btn-sm",
  role: "group",
  "aria-label": "Basic checkbox toggle button group"
}
const _hoisted_72 = {
  type: "button",
  class: "btn btn-sm",
  style: {"border-width":"4px"}
}
const _hoisted_73 = /*#__PURE__*/_createElementVNode("label", {
  class: "btn btn-outline-primary",
  for: "approve"
}, "Diterima", -1)
const _hoisted_74 = {
  type: "button",
  class: "btn btn-sm"
}
const _hoisted_75 = /*#__PURE__*/_createElementVNode("label", {
  class: "btn btn-outline-danger",
  for: "reject",
  style: {"color":"#000"}
}, "Ditolak", -1)
const _hoisted_76 = { key: 5 }
const _hoisted_77 = {
  key: 0,
  class: "modal-footer"
}
const _hoisted_78 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-danger",
  "data-bs-dismiss": "modal",
  style: {"background-color":"#e50200"}
}, " Batal ", -1)
const _hoisted_79 = {
  key: 1,
  class: "modal-footer"
}
const _hoisted_80 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-danger",
  "data-bs-dismiss": "modal",
  style: {"background-color":"#e50200"}
}, " Batal ", -1)
const _hoisted_81 = [
  _hoisted_80
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.widgetClasses, "card"])
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "btn btn-sm btn-light",
          style: {"font-weight":"400","margin-top":"0px"},
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showHideFilter && _ctx.showHideFilter(...args)))
        }, " Filter "),
        (_ctx.showFilter)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.schoolId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.schoolId) = $event)),
                      placeholder: "Pilih Sekolah",
                      mode: "single",
                      "create-option": false,
                      options: _ctx.listSekolah,
                      searchable: true,
                      label: "name",
                      "track-by": "name",
                      "value-prop": "_id",
                      "max-height": 350,
                      max: 5,
                      style: {"width":"600px"},
                      onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.pilihSekolah($event)))
                    }, null, 8, ["modelValue", "options"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.confirmation,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.confirmation) = $event)),
                      placeholder: "Pilih Status Konfirmasi",
                      mode: "single",
                      "create-option": false,
                      options: _ctx.listConfirmation,
                      searchable: true,
                      label: "label",
                      "track-by": "label",
                      "value-prop": "value",
                      "max-height": 350,
                      max: 5,
                      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sorting($event)))
                    }, null, 8, ["modelValue", "options"])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("table", _hoisted_12, [
            _hoisted_13,
            (_ctx.tableData.length)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_15, _toDisplayString(item.school_name), 1),
                      (item.legal_status === 'Approve')
                        ? (_openBlock(), _createElementBlock("td", _hoisted_16, _toDisplayString("Disetujui")))
                        : (item.legal_status === 'Reject')
                          ? (_openBlock(), _createElementBlock("td", _hoisted_17, _toDisplayString("Ditolak")))
                          : (_openBlock(), _createElementBlock("td", _hoisted_18, _toDisplayString("PKS Belum Tersedia"))),
                      _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.dateTime2(item.requested_time)), 1),
                      (item.progress_status === 'Approve')
                        ? (_openBlock(), _createElementBlock("td", _hoisted_20, _toDisplayString("Disetujui")))
                        : (item.progress_status === 'Cancel')
                          ? (_openBlock(), _createElementBlock("td", _hoisted_21, _toDisplayString("Ditolak")))
                          : (
                    item.progress_status === 'Pending' ||
                    item.progress_status === 'Waiting'
                  )
                            ? (_openBlock(), _createElementBlock("td", _hoisted_22, _toDisplayString("Menunggu")))
                            : (item.progress_status === 'Process')
                              ? (_openBlock(), _createElementBlock("td", _hoisted_23, _toDisplayString("Proses")))
                              : (_openBlock(), _createElementBlock("td", _hoisted_24, _toDisplayString("Leads"))),
                      (
                    item.confirmed_time === '' || item.confirmed_time === null
                  )
                        ? (_openBlock(), _createElementBlock("td", _hoisted_25, _toDisplayString("-")))
                        : (_openBlock(), _createElementBlock("td", _hoisted_26, _toDisplayString(_ctx.dateTime2(item.confirmed_time)), 1)),
                      (item.confirmation === 'approve')
                        ? (_openBlock(), _createElementBlock("td", _hoisted_27, _toDisplayString("Disetujui")))
                        : (item.confirmation === 'reject')
                          ? (_openBlock(), _createElementBlock("td", _hoisted_28, _toDisplayString("Ditolak")))
                          : (_openBlock(), _createElementBlock("td", _hoisted_29, _toDisplayString("Menunggu Konfirmasi Legal"))),
                      _createElementVNode("td", _hoisted_30, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-warning btn-sm",
                          title: "Detail",
                          onClick: ($event: any) => (_ctx.getId(index, item)),
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#kt_modal_confirm_legal"
                        }, _toDisplayString("Detail"), 8, _hoisted_31)
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_32, _hoisted_34))
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("select", {
                  name: "kt_customers_table_length",
                  class: "form-select form-select-sm form-select-solid",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.paging.size) = $event)),
                  placeholder: "Per page",
                  onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changePageSize()))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paging.perPageOptions, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item,
                      label: item,
                      value: item
                    }, null, 8, _hoisted_38))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.paging.size]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_39, " Showing " + _toDisplayString(_ctx.from + 1) + " to " + _toDisplayString(_ctx.to) + " of " + _toDisplayString(_ctx.paging.totalElements) + " entries ", 1)
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("ul", _hoisted_41, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item previous", { disabled: _ctx.paging.page + 1 === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
                }, " Previous ")
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item next", { disabled: _ctx.paging.page + 1 === _ctx.paging.totalPages }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
                }, " Next ")
              ], 2)
            ])
          ])
        ])
      ])
    ], 2),
    _createElementVNode("div", _hoisted_42, [
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", _hoisted_44, [
          _hoisted_45,
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _hoisted_49,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "school_name",
                  class: "form-control form-control-lg",
                  modelValue: _ctx.formDetail.school_name,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formDetail.school_name) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _hoisted_51,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "progress_responsible",
                  class: "form-control form-control-lg",
                  modelValue: _ctx.formDetail.progress_responsible,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formDetail.progress_responsible) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_52, [
                _hoisted_53,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "requested_time",
                  class: "form-control form-control-lg",
                  modelValue: _ctx.formDetail.requested_time,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formDetail.requested_time) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, [
                _hoisted_56,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "sales_area_name",
                  class: "form-control form-control-lg",
                  modelValue: _ctx.formDetail.sales_area_name,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formDetail.sales_area_name) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _hoisted_58,
                _createVNode(_component_Field, {
                  type: "text",
                  class: "form-control form-control-lg",
                  name: "progress_status",
                  modelValue: _ctx.formDetail.progress_status,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formDetail.progress_status) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _hoisted_61,
                (_ctx.roleuser === 'SUPER_ADMIN' || _ctx.roleuser === 'ADMIN_LEGAL')
                  ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                      key: 0,
                      class: "form-control form-control-lg",
                      type: "text",
                      placeholder: "Tambahkan Catatan Untuk Konfirmasi Perubahan",
                      name: "note",
                      autocomplete: "off",
                      rows: "2",
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formDetail.note) = $event))
                    }, null, 512)), [
                      [_vModelText, _ctx.formDetail.note]
                    ])
                  : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                      key: 1,
                      class: "form-control form-control-lg",
                      type: "text",
                      placeholder: "Tambahkan Catatan Untuk Konfirmasi Perubahan",
                      name: "note",
                      autocomplete: "off",
                      rows: "2",
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formDetail.note) = $event)),
                      disabled: ""
                    }, null, 512)), [
                      [_vModelText, _ctx.formDetail.note]
                    ])
              ])
            ]),
            (_ctx.roleuser === 'SUPER_ADMIN' || _ctx.roleuser === 'ADMIN_LEGAL')
              ? (_openBlock(), _createElementBlock("div", _hoisted_62, _hoisted_64))
              : (_openBlock(), _createElementBlock("div", _hoisted_65)),
            (_ctx.roleuser === 'SUPER_ADMIN' || _ctx.roleuser === 'ADMIN_LEGAL')
              ? (_openBlock(), _createElementBlock("div", _hoisted_66, _hoisted_68))
              : (_openBlock(), _createElementBlock("div", _hoisted_69)),
            (_ctx.roleuser === 'SUPER_ADMIN' || _ctx.roleuser === 'ADMIN_LEGAL')
              ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("button", _hoisted_72, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        class: "btn-check",
                        value: "approve",
                        id: "approve",
                        autocomplete: "off",
                        checked: "",
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formDetail.confirmation) = $event))
                      }, null, 512), [
                        [_vModelRadio, _ctx.formDetail.confirmation]
                      ]),
                      _hoisted_73
                    ]),
                    _createElementVNode("button", _hoisted_74, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        class: "btn-check",
                        value: "reject",
                        id: "reject",
                        autocomplete: "off",
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formDetail.confirmation) = $event))
                      }, null, 512), [
                        [_vModelRadio, _ctx.formDetail.confirmation]
                      ]),
                      _hoisted_75
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_76))
          ]),
          (_ctx.roleuser === 'SUPER_ADMIN' || _ctx.roleuser === 'ADMIN_LEGAL')
            ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                _hoisted_78,
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.submitAdd()))
                }, " Simpan ")
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_79, _hoisted_81))
        ])
      ])
    ])
  ], 64))
}